/* eslint-disable no-use-before-define */
import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl,
  FormControlLabel, InputLabel, MenuItem, Select, Switch, InputAdornment, OutlinedInput, Stack,
} from '@mui/material';
import { DialogProps } from '@mui/material/Dialog';
import ButtonTemplate from '../../../../../components/Button/Button';
import { postRegstrarEmailConsentimento } from '../../../../../services/loginAPI';

// Factory function that returns a new function that uses Hooks API.
function createHook() {
  return function useHook() {
    const [open, setOpen] = React.useState({
      status: false,
      open: () => setOpen((prevState) => (
        {
          ...prevState, status: true,
        }
      )),
      close: () => setOpen((prevState) => (
        {
          ...prevState, status: false,
        }
      )),
    });

    return open;
  };
};

export const TermoConsentimentoUseState = createHook();

interface propsType {
  open:boolean;
  handleClose: () => void;
  emailContato: string;
  emailUsuario: string;
};

export const TermoConsentimento = ({
  open, handleClose, emailContato, emailUsuario,
}: propsType): JSX.Element => {
  const history = useHistory();
  const [fullWidth, setFullWidth] = React.useState(false);
  const [maxWidth, setMaxWidth] = React.useState<DialogProps['maxWidth']>('sm');
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    setLoading(false);
  }, [open]);

  async function handleClick() {
    setLoading(true);
    const retorno = await postRegstrarEmailConsentimento(emailUsuario);
    console.log(retorno);
    if (retorno.sucesso) {
      history.push({
        pathname: '/Cadastro',
        state: { // location state
          emailCadastro: emailUsuario,
        },
      });
    }
    setLoading(false);
  };

  return (
    <>
      <Dialog
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        open={open}
        disableEscapeKeyDown
      >
        <DialogTitle>
          Termo de consentimento
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Antes de prosseguirmos com o processo de cadastro no Portal do Titular, é importante
            destacar que o seu direito à privacidade é algo muito importante para a RGM Tecnologia.
            Dessa forma, em conformidade com a Lei Geral de Proteção de Dados
            (LGPD, Lei nº 13.709/18 Art. 8º), ao aceitar esse termo, você se manifesta,
            livremente, concordando que iremos utilizar os seguintes dados para realizar (i)
            o cadastro, validação e login de seu usuário para utilização do Portal do Titular,
            (ii) a consulta, análise e atendimento às solicitações cadastradas por você no Portal
            do Titular (iii) emissão de relatórios internos sobre solicitações do Portal do Titular:
            <br />
            • Nome
            <br />
            • E-mail pessoal
            <br />
            • Número do CPF
            <br />
            • Foto
            <br />
            • Cópia de um documento pessoal (RG ou CNH)
            <br />
            Utilizaremos esses dados de forma segura, em conformidade com nossa Política de
            Privacidade que você pode conhecer clicando aqui.   Esse consentimento é válido por
            até 24 meses e é exclusivo para os dados pessoais aqui informados, e para utilização
            deles na finalidade descrita acima. Qualquer necessidade de alteração quanto a
            finalidade de tratamento desses dados será comunicada com antecedência a você, e só
            seguiremos com a mudança após sua nova aprovação. Esses dados não serão compartilhados
            com out ras empresas que não estejam diretamente envolvidas nas finalidades de
            tratamento de Dados Pessoais descritas acima. E, não se preocupe, além de poder revogar
            esse consentimento a qualquer momento, através do nosso Canal do Titular de Dados
            (pelo e-mail
            {' '}
            {emailContato}
            {' '}
            ou pelo próprio Portal do Titular, após completar todas as
            etapas de seu cadastro), você ainda tem resguardado, pelos mesmos canais, todos seus
            direitos previstos no Art. 18 da LGPD, incluindo o direito à eliminação dos dados de
            nossas bases.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={12}
            sx={{
              width: '100%',
            }}
          >
            <ButtonTemplate
              variante="loading"
              cor="cyan"
              tonalidade={800}
              onClickLoading={handleClick}
              loading={loading}
            >
              CONCORDO
            </ButtonTemplate>

            <ButtonTemplate
              type="submit"
              cor="cyan"
              tonalidade={800}
              size="large"
              onClick={handleClose}
              disabled={loading}
            >
              NÃO CONCORDO
            </ButtonTemplate>
          </Stack>
        </DialogActions>
      </Dialog>
    </>
  );
};
